// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";

import * as Env from "../Env";

const ExperimentsServiceContext = React.createContext<{
  experimentAssignments: Record<string, string>;
  osEnv: string;
}>({
  experimentAssignments: {},
  osEnv: "",
});

export const ExperimentsServiceProvider: React.FC<
  React.PropsWithChildren<{}>
> = ({ children }) => {
  return (
    <ExperimentsServiceContext.Provider
      value={{
        // Note that for website, we need to refetch experiments on login, but since the learner app is a logged-in only app,
        // we know that the learner UID will never change, so we can use the server-side experiment assignments directly.
        experimentAssignments: Env.EXPERIMENT_ASSIGNMENTS,
        osEnv: Env.OUTSCHOOL_ENV,
      }}
    >
      {children}
    </ExperimentsServiceContext.Provider>
  );
};

export function useServerExperimentContext() {
  return React.useContext(ExperimentsServiceContext);
}
